import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';

import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeCommoditiesAddTemplate } from '../../templates';
import { LandscapeCommodityResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-commodity-response.dto';
import { LandscapeCommodityAvailabilityType } from '../../../store/landscapeAPI/landscape/landscape-commodity-availability-type';
import { useNavigate, useParams } from 'react-router-dom';
import { getUUID } from '../../../utils/UUID';
import {
  fetchCommoditiesByLandscapeId,
  saveCommodityLandscape,
} from '../../../store/tradeAPI/commodity/reducers/commodity-landscape.slice';
import { LandscapeCommoditySaveRequestDto } from '../../../store/landscapeAPI/landscape/dto/request/landscape-commodity-save-request.dto';

interface LandscapeCommoditiesAddPageProps {}

const LandscapeCommoditiesAddPage: FC<
  LandscapeCommoditiesAddPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();
  const navigate = useNavigate();

  const { status } = useSelector(
    (state: RootState) => state.commodityLandscapeSlice
  );

  const [commodityLandscape, setCommodityLandscape] =
    useState<LandscapeCommodityResponseDto>({
      name: '',
      hsCode: '',
      availabilityType: LandscapeCommodityAvailabilityType.Available,
      qty: 0,
      qtyUnit: '',
      time: 0,
      timeUnit: '',
      image: '',
      compactId: id ?? '',
      commodityId: '',
      commodity: {
        name: '',
        children: [],
        hsCode: '',
        qtyUnit: '',
        timeUnit: '',
        image: '',
        id: '',
        versionId: 0,
        createdByUserId: '',
        createdOnDateTimeUtc: '',
        language: '',
        published: true,
      },
      nullable: true,
      id: getUUID(),
      versionId: 0,
      createdByUserId: '',
      createdOnDateTimeUtc: '',
      language: '',
      published: true,
    });

  const handleOnChange = (
    commodityLandscape: LandscapeCommodityResponseDto
  ) => {
    setCommodityLandscape(commodityLandscape);
  };

  const callbackFn = async (
    commodityLandscape: LandscapeCommodityResponseDto
  ) => {
    const commodityLandscapeToSave: LandscapeCommoditySaveRequestDto = {
      availabilityType: commodityLandscape.availabilityType,
      qty: commodityLandscape.qty,
      time: commodityLandscape.time,
      compactId: commodityLandscape.compactId,
      commodityId: commodityLandscape.commodityId,
      id: commodityLandscape.id,
      published: commodityLandscape.published,
    };
    await dispatch(saveCommodityLandscape(commodityLandscapeToSave));
    if (id) {
      dispatch(fetchCommoditiesByLandscapeId(id));
    }
    navigate(`/landscapes/edit/${id}/commodities`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeCommoditiesAddTemplate
      commodityLandscape={commodityLandscape}
      handleOnChange={handleOnChange}
      callbackFn={callbackFn}
    />
  );
};

export default LandscapeCommoditiesAddPage;
